<template>
  <div class="adminPage">
    <template v-if="$route.name == 'AdminLogin'">
      <AdminLogin></AdminLogin>
    </template>
    <template v-else>
      <Navigation></Navigation>
      <router-view></router-view>
    </template>
  </div>    
</template>

<script>
import AdminLogin from '@/components/admin/AdminLogin'
import Navigation from '@/components/admin/Navigation'
export default {
  components: { AdminLogin, Navigation },
}
</script>

<style lang="scss" scoped>
.adminPage {
  height: 100%;
  background-color: white;
  overflow-x: hidden;
  *::-webkit-scrollbar {
    width: auto;
    height: auto;
    background: #f1f1f1; 
  }
  *::-webkit-scrollbar-thumb {
    -webkit-border-radius: 0;
    border-radius: 0;
    background: #c1c1c1; 
  }
  *::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8; 
  }
  .table {
    overflow-x: scroll;
    min-height: calc(100vh - 171px);
    max-height: calc(100vh - 171px);
  }
  .table-header {
    color: #999999;
    background: #f6f6f6;
  }
  .table-content {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.03);
    }
  }
  .table-header, .table-content {
    display: inline-flex;
    flex-wrap: nowrap;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 300;
    text-align: center;
    align-items: center;
    min-width: 100%;
    .col {
      @extend .text-ellipsis;
      min-width: 200px;
      max-width: 200px;
      padding: 0 12px;
      white-space: normal;
      &:first-child {
        display: flex;
        align-items: center;
        text-align: left;
        justify-content: flex-start;
      }
    }
  }
}
</style>